import {get, pick} from 'lodash';
import FormModel from '@baidu/ve-ria/views/FormModel';

export default class ARDetailModel extends FormModel {

    /**
     * @override
     */
    title = '';

    /**
    * @override
    */
    crumbData = [
        {
            to: '/app/service/list',
            text: '服务管理'
        },
        {
            text: '查看AR服务'
        }
    ];

    /**
     * @override
     */
    formData = {
        name: '',
        status: '',
        comment: '',
        aderName: '',
        previewCode: '',
        statusInfo: {},
        templateId: ''
    };

    steps = [];

    map = {};

    isTemplateType = false;

    /**
     * @override
     */
    init() {
        super.init();

        this.id = this.getRouteParams().serviceId;
        this.copyService = this.api.appServiceCopy;
        this.submitAudit = this.api.appServiceARPublish;
        this.map = this.getConstantMap('APP_SERVICE_STATUS');
        this.isAdmin = !!this.getRouteMeta().isAdmin;
        this.detailRequester = this.api.appServiceARDetail;

        this.setCrumbData();
    }

    /**
     * @override
     */
    adaptData(data) {
        const formData = {
            statusInfo: this.getStatusClass(data.status),
            templateId: get(data, 'serviceData.templateId', ''),
            comment: this.getComment(data.reviewComment || '{}'),
            previewCode: get(data, 'serviceData.previewCode', '')
        };
        this.isTemplateType = get(data, 'serviceData.arTemplateType') !== 'AR_TEMPLATE_EDITOR';
        this.prepareSteps(this.isTemplateType && this.from !== 'edit');

        return {
            ...formData,
            ...pick(data, ['name', 'aderName', 'status'])
        };
    }

    prepareSteps(hasSteps) {
        if (hasSteps) {
            this.steps = [
                {
                    label: '填写基本信息'
                },
                {
                    label: '选择AR模板'
                },
                {
                    label: '配置AR物料'
                },
                {
                    label: '预览AR物料'
                }
            ];
        }
        else {
            this.steps = [];
        }
    }

    getComment(data = '{}') {
        const parsedData = JSON.parse(data);
        const status = get(parsedData, 'rdReviewComment.status');
        if (status === 'FAILED') {
            return get(parsedData, 'rdReviewComment.rejectReason', '审核失败');
        }
        return '';
    }

    getStatusClass(status) {
        switch (status) {
            case 'ONLINE':
            case 'PUBLISHED':
                return {
                    cls: 'text-success',
                    text: this.map[status]
                };
            case 'DRAFT':
            case 'REVIEWING':
                return {
                    cls: 'text-disable',
                    text: this.map[status]
                };
            case 'REJECT':
                return {
                    cls: 'text-danger',
                    text: this.map[status]
                };
        }
        return {
            cls: 'text-disable',
            text: '草稿'
        };
    }

    setCrumbData() {
        const query = this.getRouteQuery();
        this.from = query.from || 'edit';
        this.crumbData[0].to = this.isAdmin ? '/service/reviewing/list' : '/app/service/list';
        switch (this.from) {
            case 'create':
                this.crumbData[1].text = '新建AR服务';
                break;
            case 'copy':
                this.crumbData[1].text = '复制AR服务';
                break;
            case 'viewDetail':
                this.crumbData[1].text = '查看AR服务';
                break;
        }
    }
}
